import { SelectableCard } from '@juvare/common-web-ui/Cards/SelectableCard';
import { themeColors } from '@juvare/common-web-ui/JuvareTheme';
import { Box, CircularProgress, Radio, Typography } from '@mui/material';
import React from 'react';
import { BadgeTemplatePreview } from '../../badge-preview/components/BadgeTemplatePreview';
import { useStorageGetBadgeTemplate } from '../hooks/useStorageGetBadgeTemplate';
export const BadgeTemplateSelectOption = ({ badgeTemplate, selected, onSelect }) => {
    const { data: badgeTemplateData, isLoading } = useStorageGetBadgeTemplate(badgeTemplate.id);
    const handleClick = () => {
        if (!badgeTemplateData)
            return;
        onSelect(badgeTemplateData);
    };
    return (React.createElement(SelectableCard, { selected: selected, onCardClick: handleClick, cardAriaLabel: 'Selece Card 1', sx: { display: 'flex', flexDirection: 'column', alignItems: 'end', height: '100%' } },
        React.createElement(Radio, { checked: selected, size: 'small' }),
        React.createElement(Box, { sx: { px: 2, pb: 2, display: 'flex', flexDirection: 'column', gap: 2, width: '100%' } },
            isLoading && (React.createElement(Box, { sx: { display: 'flex', justifyContent: 'center', alignItems: 'center', py: 3 } },
                React.createElement(CircularProgress, { size: 20 }))),
            badgeTemplateData && (React.createElement(BadgeTemplatePreview, { badgeTemplateClassifier: badgeTemplateData, badgeTemplate: badgeTemplateData.data.badgeTemplateFront, formSettings: badgeTemplateData.data.defaultFormSettings, account: badgeTemplateData.data.defaultSampleAccountData, sx: {
                    borderStyle: 'solid',
                    borderWidth: 1,
                    borderColor: themeColors.border.main,
                    borderRadius: 0.5,
                    aspectRatio: '394 / 624',
                    overflow: 'hidden',
                    boxSizing: 'content-box',
                } })),
            React.createElement(Typography, { variant: 'subtitle2', align: 'center', color: themeColors.text.link }, badgeTemplate.columns.title))));
};
